$ = require 'jquery'
WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
Auth = require 'app/scripts/db/auth'
Controller = require 'app/scripts/controller'
templates = require 'app/scripts/views/internal/templates'
{ trackUe, Noun, Verb } = require '@trello/analytics'
Util = require 'app/scripts/lib/util'

module.exports = class OverdueBannerView extends WarningBannerView
  className: Util.extendParentClassName('overdue-banner')

  events:
    'click .js-update-billing-information': 'updateBillingInformation'
    'click .js-dismiss-overdue-banner': 'dismiss'

  getMessageName: ->
    paidAccount = @model.get('paidAccount')
    billingDate = new Date(paidAccount.billingDates?[paidAccount.products?[0]]).getTime()
    "OverdueBanner-#{@model.id}-#{billingDate}"

  render: ->
    trackUe({
      category: Noun.OVERDUE_BANNER,
      verb: Verb.SHOWS,
      directObj: Noun.UPDATE_PAYMENT_METHOD_PROMPT,
      context: {
        ixSubscriber: @model.get('paidAccount')?.ixSubscriber,
        teamId: @model?.id,
        isTeamAdmin: true
      }
    })
    data =
      team: @model.get('displayName')
      billingUrl: Controller.getOrganizationBillingUrl(@model)
    @$el.html templates.fill('header_overdue_banner', data)

    @

  updateBillingInformation: ->
    trackUe({
      category: Noun.OVERDUE_BANNER,
      verb: Verb.OPENS,
      directObj: Noun.BILLING_PAGE,
      method: 'by clicking banner link',
      context: {
        ixSubscriber: @model.get('paidAccount')?.ixSubscriber,
        teamId: @model?.id,
        isTeamAdmin: true
      }
    })
    Auth.me().dismiss @getMessageName()

  dismiss: (e) ->
    trackUe({
      category: Noun.OVERDUE_BANNER,
      verb: Verb.DISMISSES,
      directObj: Noun.OVERDUE_BANNER,
      method: 'by clicking dismiss button',
      context: {
        ixSubscriber: @model.get('paidAccount')?.ixSubscriber,
        teamId: @model?.id,
        isTeamAdmin: true
      }
    })
    Auth.me().dismiss @getMessageName()
    $('.overdue-banner').remove()
    e.preventDefault()
